import { render, staticRenderFns } from "./aiProblem.vue?vue&type=template&id=3f02a7c2"
import script from "./aiProblem.vue?vue&type=script&lang=js"
export * from "./aiProblem.vue?vue&type=script&lang=js"
import style0 from "./aiProblem.vue?vue&type=style&index=0&id=3f02a7c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports